import { Col, Layout, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import AuthInfo from '../components/utilities/auth-info/info';
import balkenLogo from '../static/img/balken/balken_logo_BALKEN.png';
import hamburgerLeft from '../static/img/icon/left.svg';
import hamburgerRight from '../static/img/icon/right.svg';
const { Header } = Layout;

export default function HeaderBalken({  toggleCollapsed, collapsed, logoHeader, onShowHide, hide }) {
  const iconSrc = collapsed ? hamburgerRight : hamburgerLeft;

  return (
    <Header
      style={{
        position: 'fixed',
        width: '100%',
        top: 0,
      }}
    >
      <Row gutter={20} align="middle">
        <Col>
          <img src={iconSrc} className="cursor-pointer mb-5" alt="menu" onClick={toggleCollapsed} />
        </Col>

        <Col flex="1">
          <Link to="/inicio">
            <img src={balkenLogo} alt="logo" className="header-logo" style={{ width: '120px' }} />
          </Link>
        </Col>

        <Col>
          <AuthInfo />
        </Col>
      </Row>
    </Header>
  );
}
